import Swal from 'sweetalert2';

export const Globals = {
	validateInteger: (value) => {
		return /^\d+$/.test(value);
	},

	confirm: (message, callback) => {
		Swal.fire({
			title: "",
			text: message,
			icon: "question",
			showCancelButton: true,
			confirmButtonText: 'Aceptar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#3ace76',
		}).then((confirm) => {
			if (confirm.value) {
				callback();
			}
		});
	}
}